module.exports = __webpack_public_path__ + "assets/retina_SquareByAdjMidpointsDetailed.802b49149fbab8fa7d45e23cab8e2d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_SquareByAdjMidpointsDetailed.png
// module id = 719
// module chunks = 0